<template>
  <div>Acivating account...</div>
</template>

<script>
import { mapState } from 'vuex';
import Axios from 'axios';
import { cloudFunctions } from '../config';

export default {
  name: 'Activate',

  data: () => ({
    uid: null,
    userType: null,
  }),

  computed: {
    ...mapState(['user_data']),
  },

  beforeMount() {
    // dummy component, activation in app.vue
    this.uid = this.$route.params.uid;
    this.userType = this.$route.params.userType;
    console.log(this.uid);
  },
};
</script>
